import { CRMFeatureFlags } from '../types'
import { GOOGLE_SHEETS_AUTHORIZATION } from '@dtx-company/true-common/src/constants/featureFlags'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

export const useCRMFeatureFlags = (): CRMFeatureFlags => {
  const [isGSheetsEnabled] = useFlowFeature(GOOGLE_SHEETS_AUTHORIZATION)
  return { isGSheetsEnabled }
}
